$(function() {
  $('body').on('bless', function(e) {
    const $target = $(e.target),
      $plusmin = $target.is('.form-group--plusmin')
        ? $target
        : $target.find('.form-group--plusmin')

    $plusmin.each(function(e) {
      const $el = $(this),
        $input = $el.find('[type="number"]'),
        $buttons = $el.find('.form-group__plusmin-button'),
        step = $input.attr('step'),
        min = $input.attr('min'),
        lowerLimit = min ? parseFloat(min) : 0
      const increment = step ? parseFloat(step) : 1

      $buttons.off('click.plusmin').on('click.plusmin', function(e) {
        const oldVal = $input.val()
        let newVal = lowerLimit
        if ($(this).hasClass('form-group__plus-button')) {
          newVal = parseFloat(oldVal) + increment
        } else {
          if (oldVal > lowerLimit) {
            newVal = parseFloat(oldVal) - increment
          }
        }

        $input.val(newVal)
      })
    })
  })
})
